import styled, { css } from 'styled-components';
import {
  Space,
  Checkbox,
  Dropdown,
  Button,
  TableRow,
  InputField,
  TableCell,
} from '@cashfree-intl/coherent';

export const UpfrontTDRFormTopSection = styled(Space)`
  background: #fff;
  border-radius: 0.5rem 0.5rem 0px 0px;
  border: 1px solid #e6e9ee;
`;

export const UpfrontTDRFormBottomSection = styled.div`
  border-radius: 8px;
  border-radius: 0px 0px 0.5rem 0.5rem;
  border: 1px solid #e6e9ee;
  border-top: 0;
  background: #fff;
`;

export const StyledCheckbox = styled(Checkbox)`
  &&&.ui.checkbox {
    min-height: unset;
  }
`;

export const StyledToolTipDivider = styled.div`
  border: 1px solid var(--TABLE_COLUMN);
`;

export const DropdownCTAGroup = styled(Space)`
  border-top: 1px solid #e6e9ee;
  position: sticky;
  bottom: 0px;
  background: white;
  z-index: 999;
`;

export const StyledDropdown = styled(Dropdown)`
  &&&.ui.selection.dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    min-height: unset;
    max-height: 40px;
    max-width: 220px;

    .default.text,
    .divider.text {
      font-size: 14px;
    }

    &.elements-selected {
      .default.text {
        color: #2b2d42;
      }
    }
  }
`;

export const StyledRadioGroup = styled.div`
  .inline.fields {
    margin-top: 0;
  }
  .ui.radio.checkbox label {
    margin-bottom: 8px;
  }
`;

export const StyledInputWithAction = styled.div`
  .ui.labeled.input {
    margin-bottom: 0;
    .label {
      border-bottom-left-radius: 6px;
      border-top-left-radius: 6px;
      width: 43px;
    }
    input {
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
      width: 181px;
      max-width: unset;
    }
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.6fr 1fr;
`;

export const StyledGridV2 = styled.div`
  display: grid;
  grid-template-columns: 0.2fr 0.8fr;

  .tdr-amount-fields {
    .field .ui.input {
      margin-bottom: 0;
    }
  }

  .ui.input input {
    max-width: 224px;
  }
`;

export const StyledButton = styled(Button)`
  max-width: 140px;
`;

export const StyledSelectCheckbox = styled(Checkbox)`
  &&&.ui.fitted.checkbox {
    min-height: 17px;
  }
`;

export const StyledChipsWrapper = styled(Space)`
  max-width: 220px;
`;

export const StyledChip = styled(Space)`
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  background: #e6e9ee;
`;

interface IBorderStylesProps {
  highlight?: boolean;
}

const borderStyles = css`
  border: ${(props: IBorderStylesProps) =>
  props.highlight && '1px solid rgba(105, 48, 202, 0.25)'};
  border-radius: ${(props: IBorderStylesProps) => props.highlight && '0.5rem'};
`;

export const HighlighterDiv = styled.div`
  ${borderStyles}
  -webkit-animation: ${(props: IBorderStylesProps) =>
  props.highlight && 'pulse 2s 1'};
  -moz-animation: ${(props: IBorderStylesProps) =>
    props.highlight && 'pulse 2s 1'};

  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(105, 48, 202, 0.25);
    }
    70% {
      -webkit-box-shadow: 0 0 0 0.5rem #efe5ff;
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 #efe5ff;
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(105, 48, 202, 0.25);
      box-shadow: 0 0 0 0 rgba(105, 48, 202, 0.25);
    }
    70% {
      -moz-box-shadow: 0 0 0 0.5rem #efe5ff;
      box-shadow: 0 0 0 0.5rem #efe5ff;
    }
    100% {
      -moz-box-shadow: 0 0 0 0 #efe5ff;
      box-shadow: 0 0 0 0 #efe5ff;
    }
  }
`;

export const StyledTableRow = styled(TableRow)`
  .ui.table tr&& {
    background-color: ${props =>
      props.highlightRow ? 'var(--SELECTED)' : 'white'};
  }
`;

export const StyledInputField = styled(InputField)`
  .ui.input {
    margin-bottom: 0;
    input:focus {
      border-color: var(--PRIMARY);
    }
  }
`;

export const StyledTwoColumnRow = styled(Space)`
  .ui.input input {
    height: 40px;
  }
`;

export const StyledSlabCtaWrapper = styled(Space)`
  .rounded-add {
    height: 18px;
    width: 18px;
  }
`;

export const StyledFormWrapper = styled.div`
  max-height: 542px;
  overflow-y: auto;
  padding: 24px 32px;
`;

export const StyledFormButtonWrapper = styled(Space)`
  padding: 24px 32px;
  border-top: 1px solid var(--TABLE_COLUMN);
`;

export const ExternalPMRTableCell = styled(TableCell)`
  border-bottom: 1px solid var(--DISABLED) !important;
  &:first-child {
    border-left: 1px solid var(--DISABLED) !important;
  }
  &:last-child {
    border-right: 1px solid var(--DISABLED) !important;
  }
`;

export const StyledTableCTAItem = styled.span`
  svg {
    vertical-align: middle;
    margin-bottom: 4px;
    margin-left: 2px;
  }
`;

export const StyledTDRSlabFormWrapper = styled.div`
  .ui.input input {
    height: 40px;
  }
`;

export const StyledPMRTable = styled.div`
  overflow-x: auto;
  table {
    min-width: 75rem;
  }
`;
